import styled from "styled-components";

export const Wrapper = styled.div`
  .deleteButton {
    display: flex;
    margin-left: 10px;
  }
  .addButton {
    display: flex;
  }
`;

export const PaymentWrapper = styled.div`
  .modal-input {
    border: 1px solid #dddddd;
    font-size: 15px;
  }
  .modal-label {
    color: #566787;
    padding-bottom: 2px;
  }
`;
